<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar />

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">LABORATORY</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('hospital-dashboard')">Hospital</a></li>
                      <li class="breadcrumb-item active">Laboratory</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stats Cards -->
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'pending'}" @click="activeTab = 'pending'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Pending</p>
                        <h4 class="mb-0">{{ stats.pending || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-warning">
                        <span class="avatar-title bg-transparent text-warning">
                          <i class="mdi mdi-clock-outline font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'collection'}" @click="activeTab = 'collection'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Sample Collection</p>
                        <h4 class="mb-0">{{ stats.sampleCollection || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-info">
                        <span class="avatar-title bg-transparent text-info">
                          <i class="mdi mdi-test-tube font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'results'}" @click="activeTab = 'results'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Awaiting Results</p>
                        <h4 class="mb-0">{{ stats.awaitingResults || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-primary">
                        <span class="avatar-title bg-transparent text-primary">
                          <i class="mdi mdi-flask font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'completed'}" @click="activeTab = 'completed'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Completed Today</p>
                        <h4 class="mb-0">{{ stats.completed || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-success">
                        <span class="avatar-title bg-transparent text-success">
                          <i class="mdi mdi-check-circle font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content Card -->
            <div class="card">
              <div class="card-body">
                <!-- Header with Tabs and Filters -->
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
                  <div>
                    <h5 class="mb-1"><i class="mdi mdi-microscope me-2 text-primary"></i>Lab Requests</h5>
                    <p class="text-muted mb-0">Manage laboratory test requests and results</p>
                  </div>
                  <div class="d-flex gap-2">
                    <input type="date" class="form-control" v-model="dateFrom" @change="loadRequests" style="width: 140px;">
                    <input type="date" class="form-control" v-model="dateTo" @change="loadRequests" style="width: 140px;">
                    <button class="btn btn-soft-primary" @click="loadRequests">
                      <i class="mdi mdi-refresh"></i> Refresh
                    </button>
                  </div>
                </div>

                <!-- Tabs -->
                <ul class="nav nav-tabs nav-tabs-custom mb-4">
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'pending'}" href="javascript:void(0);" @click="activeTab = 'pending'">
                      Pending <span class="badge bg-warning ms-1">{{ stats.pending || 0 }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'collection'}" href="javascript:void(0);" @click="activeTab = 'collection'">
                      Sample Collection <span class="badge bg-info ms-1">{{ stats.sampleCollection || 0 }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'results'}" href="javascript:void(0);" @click="activeTab = 'results'">
                      Enter Results <span class="badge bg-primary ms-1">{{ stats.awaitingResults || 0 }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'completed'}" href="javascript:void(0);" @click="activeTab = 'completed'">
                      Completed <span class="badge bg-success ms-1">{{ stats.completed || 0 }}</span>
                    </a>
                  </li>
                </ul>

                <!-- Loading -->
                <div v-if="loading" class="text-center py-5">
                  <div class="spinner-border text-primary mb-3"></div>
                  <p class="text-muted mb-0">Loading lab requests...</p>
                </div>

                <!-- Requests Table -->
                <div v-else-if="filteredRequests.length > 0" class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Request ID</th>
                        <th>Patient</th>
                        <th>Test</th>
                        <th>Priority</th>
                        <th>Sample</th>
                        <th>Status</th>
                        <th>Requested</th>
                        <th style="width: 150px;">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="request in filteredRequests" :key="request.requestID">
                        <td>
                          <span class="fw-medium text-primary">{{ request.requestID }}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm me-2">
                              <span class="avatar-title rounded-circle" :class="request.gender === 'Male' ? 'bg-primary' : 'bg-pink'">
                                {{ getInitials(request.patientName) }}
                              </span>
                            </div>
                            <div>
                              <h6 class="mb-0">{{ request.patientName }}</h6>
                              <small class="text-muted">{{ request.gender }} • {{ request.age }} yrs</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span class="fw-medium">{{ request.testName }}</span>
                          <small class="text-muted d-block">{{ request.sampleType || '-' }}</small>
                        </td>
                        <td>
                          <span class="badge" :class="getPriorityBadge(request.priority)">
                            {{ request.priority }}
                          </span>
                        </td>
                        <td>
                          <span v-if="request.sampleCollected === 'Yes'" class="text-success">
                            <i class="mdi mdi-check-circle me-1"></i>{{ request.sampleID }}
                          </span>
                          <span v-else class="text-muted">
                            <i class="mdi mdi-minus-circle me-1"></i>Not Collected
                          </span>
                        </td>
                        <td>
                          <span class="badge" :class="getStatusBadge(request.status)">
                            {{ request.status }}
                          </span>
                        </td>
                        <td>
                          <small>{{ formatDateTime(request.requestDate || request.dateCreated) }}</small>
                          <small class="text-muted d-block">{{ request.orderingDoctorName }}</small>
                        </td>
                        <td>
                          <div class="d-flex gap-1">
                            <!-- Pending: Collect Sample -->
                            <button v-if="request.status === 'Pending'" 
                                    class="btn btn-sm btn-soft-info" 
                                    @click="openCollectSample(request)"
                                    title="Collect Sample">
                              <i class="mdi mdi-test-tube"></i>
                            </button>
                            
                            <!-- Sample Collected: Enter Results -->
                            <button v-if="request.status === 'Sample Collected'" 
                                    class="btn btn-sm btn-soft-primary"
                                    @click="goToResults(request)"
                                    title="Enter Results">
                              <i class="mdi mdi-flask"></i>
                            </button>
                            
                            <!-- Completed: View Results -->
                            <button v-if="request.status === 'Completed'" 
                                    class="btn btn-sm btn-soft-success"
                                    @click="viewReport(request)"
                                    title="View Report">
                              <i class="mdi mdi-file-document"></i>
                            </button>
                            
                            <!-- Print Label -->
                            <button v-if="request.sampleCollected === 'Yes'" 
                                    class="btn btn-sm btn-soft-secondary"
                                    @click="printLabel(request)"
                                    title="Print Label">
                              <i class="mdi mdi-printer"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Empty State -->
                <div v-else class="text-center py-5">
                  <div class="empty-state-icon mb-3">
                    <i class="mdi mdi-flask-empty-outline"></i>
                  </div>
                  <h5 class="mb-2">No lab requests found</h5>
                  <p class="text-muted mb-0">There are no {{ activeTab }} lab requests for the selected date range.</p>
                </div>

              </div>
            </div>

          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">County Hospital Management System</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- Collect Sample Modal -->
    <div class="modal fade" id="collectSampleModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="mdi mdi-test-tube me-2"></i>Collect Sample</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" v-if="selectedRequest">
            <!-- Patient Info -->
            <div class="alert alert-light mb-3">
              <div class="d-flex align-items-center">
                <div class="avatar-sm me-2">
                  <span class="avatar-title rounded-circle bg-primary">
                    {{ getInitials(selectedRequest.patientName) }}
                  </span>
                </div>
                <div>
                  <h6 class="mb-0">{{ selectedRequest.patientName }}</h6>
                  <small class="text-muted">{{ selectedRequest.patientID }}</small>
                </div>
              </div>
            </div>

            <!-- Test Info -->
            <div class="mb-3">
              <label class="form-label text-muted">Test</label>
              <p class="mb-0 fw-medium">{{ selectedRequest.testName }}</p>
            </div>

            <div class="row mb-3">
              <div class="col-6">
                <label class="form-label text-muted">Sample Type</label>
                <p class="mb-0">{{ selectedRequest.sampleType || 'Not specified' }}</p>
              </div>
              <div class="col-6">
                <label class="form-label text-muted">Priority</label>
                <span class="badge" :class="getPriorityBadge(selectedRequest.priority)">{{ selectedRequest.priority }}</span>
              </div>
            </div>

            <!-- Sample ID Input -->
            <div class="mb-3">
              <label class="form-label">Sample ID / Barcode <span class="text-danger">*</span></label>
              <div class="input-group">
                <span class="input-group-text"><i class="mdi mdi-barcode"></i></span>
                <input type="text" class="form-control" v-model="sampleID" placeholder="Scan or enter sample ID" autofocus>
                <button class="btn btn-outline-secondary" type="button" @click="generateSampleID">
                  <i class="mdi mdi-auto-fix"></i> Generate
                </button>
              </div>
            </div>

            <!-- Clinical Info -->
            <div v-if="selectedRequest.clinicalInfo" class="mb-3">
              <label class="form-label text-muted">Clinical Information</label>
              <p class="mb-0 small">{{ selectedRequest.clinicalInfo }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="collectSample" :disabled="!sampleID || collecting">
              <span v-if="collecting"><i class="mdi mdi-loading mdi-spin me-1"></i> Processing...</span>
              <span v-else><i class="mdi mdi-check me-1"></i> Confirm Collection</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast Notification -->
    <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "LabDashboard",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      loading: true,
      collecting: false,
      activeTab: 'pending',
      
      // Date filters
      dateFrom: new Date().toISOString().split('T')[0],
      dateTo: new Date().toISOString().split('T')[0],
      
      // Data
      requests: [],
      stats: {
        pending: 0,
        sampleCollection: 0,
        awaitingResults: 0,
        completed: 0
      },
      
      // Sample collection
      selectedRequest: null,
      sampleID: '',
      
      // Session
      facilityID: '',
      facilityName: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    filteredRequests() {
      if (!this.requests || this.requests.length === 0) return [];
      
      switch (this.activeTab) {
        case 'pending':
          return this.requests.filter(r => r.status === 'Pending');
        case 'collection':
          return this.requests.filter(r => r.status === 'Pending' && r.sampleCollected !== 'Yes');
        case 'results':
          return this.requests.filter(r => r.status === 'Sample Collected');
        case 'completed':
          return this.requests.filter(r => r.status === 'Completed');
        default:
          return this.requests;
      }
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    showSuccess(message) {
      if (this.$refs.toast) {
        this.$refs.toast.success(message);
      } else {
        console.log('Success:', message);
      }
    },

    showError(message) {
      if (this.$refs.toast) {
        this.$refs.toast.error(message);
      } else {
        console.error('Error:', message);
        alert(message);
      }
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    formatDateTime(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString('en-GB', { 
        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' 
      });
    },

    getPriorityBadge(priority) {
      switch (priority) {
        case 'STAT': return 'bg-danger';
        case 'Urgent': return 'bg-warning text-dark';
        default: return 'bg-secondary';
      }
    },

    getStatusBadge(status) {
      switch (status) {
        case 'Pending': return 'bg-warning text-dark';
        case 'Sample Collected': return 'bg-info';
        case 'Processing': return 'bg-primary';
        case 'Completed': return 'bg-success';
        case 'Verified': return 'bg-success';
        default: return 'bg-secondary';
      }
    },

    loadRequests() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getLabRequests");
      data.append("facilityID", this.facilityID);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, hospital)
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.requests = res.data.data.labRequests || [];
            this.calculateStats();
          } else {
            this.requests = [];
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
          this.requests = [];
        });
    },

    calculateStats() {
      this.stats = {
        pending: this.requests.filter(r => r.status === 'Pending').length,
        sampleCollection: this.requests.filter(r => r.status === 'Pending' && r.sampleCollected !== 'Yes').length,
        awaitingResults: this.requests.filter(r => r.status === 'Sample Collected').length,
        completed: this.requests.filter(r => r.status === 'Completed').length
      };
    },

    openCollectSample(request) {
      this.selectedRequest = request;
      this.sampleID = '';
      const modal = new bootstrap.Modal(document.getElementById('collectSampleModal'));
      modal.show();
    },

    generateSampleID() {
      const date = new Date();
      const dateStr = date.getFullYear().toString().slice(-2) + 
                      String(date.getMonth() + 1).padStart(2, '0') + 
                      String(date.getDate()).padStart(2, '0');
      const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      this.sampleID = 'S' + dateStr + random;
    },

    collectSample() {
      if (!this.sampleID || !this.selectedRequest) return;

      this.collecting = true;

      const data = new FormData();
      data.append("function", "collectSample");
      data.append("requestID", this.selectedRequest.requestID);
      data.append("sampleID", this.sampleID);
      data.append("collectedBy", this.sessionNames);
      data.append("sessionNames", this.sessionNames);
      data.append("sessionIdNo", this.sessionIdNo);

      execute(data, hospital)
        .then((res) => {
          this.collecting = false;
          if (res.data.success) {
            this.showSuccess('Sample collected successfully');
            bootstrap.Modal.getInstance(document.getElementById('collectSampleModal')).hide();
            this.loadRequests();
          } else {
            this.showError(res.data.message || 'Failed to collect sample');
          }
        })
        .catch((e) => {
          this.collecting = false;
          console.error(e);
          this.showError('Error collecting sample');
        });
    },

    goToResults(request) {
      this.$router.push('/lab-results/' + request.requestID);
    },

    viewReport(request) {
      this.$router.push('/lab-report/' + request.requestID);
    },

    printLabel(request) {
      const labelContent = `
        <html>
        <head>
          <title>Lab Sample Label</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 10px; }
            .label { border: 2px solid #000; padding: 10px; width: 250px; }
            .sample-id { font-size: 18px; font-weight: bold; text-align: center; margin: 5px 0; letter-spacing: 2px; }
            .info { font-size: 11px; margin-top: 4px; }
            .test { font-size: 12px; font-weight: bold; margin-top: 8px; border-top: 1px dashed #000; padding-top: 5px; }
          </style>
        </head>
        <body>
          <div class="label">
            <div class="sample-id">${request.sampleID}</div>
            <div class="info"><strong>Patient:</strong> ${request.patientName}</div>
            <div class="info"><strong>ID:</strong> ${request.patientID}</div>
            <div class="test">${request.testName}</div>
            <div class="info"><strong>Date:</strong> ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}</div>
          </div>
        </body>
        </html>
      `;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(labelContent);
      printWindow.document.close();
      printWindow.print();
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.facilityName = sessionStorage.getItem("hospitalFacilityName") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    const today = new Date();
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);
    this.dateFrom = weekAgo.toISOString().split('T')[0];
    this.dateTo = today.toISOString().split('T')[0];

    this.loadRequests();
  }
};
</script>

<style scoped>
.avatar-sm { width: 2.25rem; height: 2.25rem; }
.avatar-md { width: 3rem; height: 3rem; }
.avatar-title { 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  width: 100%; 
  height: 100%; 
  font-weight: 600; 
  color: #fff;
  font-size: 0.75rem;
}

.bg-pink { background-color: #e83e8c !important; }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.15) !important; }
.bg-soft-info { background-color: rgba(23, 162, 184, 0.15) !important; }
.bg-soft-primary { background-color: rgba(85, 110, 230, 0.15) !important; }
.bg-soft-success { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-soft-secondary { background-color: rgba(116, 120, 141, 0.15) !important; }

.card-stat {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.card-stat:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.card-stat.active {
  border-color: #556ee6;
  background: linear-gradient(135deg, #f8f9ff 0%, #fff 100%);
}

.empty-state-icon {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.empty-state-icon i {
  font-size: 40px;
  color: #adb5bd;
}

.card {
  border: none;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.table > :not(caption) > * > * {
  padding: 0.75rem;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.nav-tabs-custom .nav-link {
  border: none;
  color: #74788d;
  padding: 0.5rem 1rem;
}

.nav-tabs-custom .nav-link.active {
  color: #556ee6;
  border-bottom: 2px solid #556ee6;
  background: transparent;
}

.btn-soft-info { background-color: rgba(23, 162, 184, 0.15); color: #17a2b8; }
.btn-soft-info:hover { background-color: #17a2b8; color: #fff; }

.btn-soft-primary { background-color: rgba(85, 110, 230, 0.15); color: #556ee6; }
.btn-soft-primary:hover { background-color: #556ee6; color: #fff; }

.btn-soft-success { background-color: rgba(52, 195, 143, 0.15); color: #34c38f; }
.btn-soft-success:hover { background-color: #34c38f; color: #fff; }

.btn-soft-secondary { background-color: rgba(116, 120, 141, 0.15); color: #74788d; }
.btn-soft-secondary:hover { background-color: #74788d; color: #fff; }
</style>
